export default "__VITE_ASSET__CYzBNSep__"